import { useTranslations } from '@vocab/react';
import { Alert, Text } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';
// TODO : Waiting to finalise this message
export const AutoRejectBanner: FC = () => {
  const { t } = useTranslations(translations);
  return (
    <Alert tone="info" data={{ testid: 'autoRejectBanner' }}>
      <Text size="small">
        {t(
          "As you have opted in, applicants who don't meet your must-have requirements are automatically moved to Not Suitable folder.",
        )}
      </Text>
    </Alert>
  );
};
